export default __webpack_public_path__ + "static/media/techcrunchCL.b8889a72.webp";